import React, { useContext } from 'react'

import clsx from 'clsx'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import Container from 'karrierhub-ui/dist/common/src/components/Container'

import AppContext from '../../App/context'
import Form from '../../Form'

import style from './style.css'
import AccountContext from '../context'
import capitalize from '../../../utils/capitalize'
import { postTypesConfig } from '../../../postTypes'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

function NotificationSettings(props) {

    const {
        SubmitProps = {},
        TypographyProps = {}
    } = props

    const accountContext = useContext(AccountContext)
    const { user, name } = accountContext

    const N = capitalize(name)

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)
    const utils = getUtils(context)

    const { wapp } = context

    async function onSubmit(e, formData) {
        return await utils.sendRequest({
            requestName: name + 'SaveNotificationSettings',
            args: formData,
            redirect: null
        })
    }

    let formDataFromResolvers = {}
    try {
        formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'SaveNotificationSettings.formData')
    } catch (e) {
    }

    const formData = {
        ...formDataFromResolvers,
        submit: {
            label: appContext.labels['save' + N + 'SubmitLabel'],
            fullWidth: true,
            ...SubmitProps
        }
    }

    if (user?._id) {
        formData._id.value = user
        formData._id.disabled = true
        formData._id.refPostType = name
    }

    if (user?._id) {
        Object.keys(formData).forEach(function(key) {
            if (key.startsWith('record.')) {
                const ka = key.split('.')
                let value = user
                ka.forEach(function(nk) {
                    if (nk !== 'record') {
                        if ((value && value[nk]) || (value && value[nk] === 0) || (value && value[nk] === false)) {
                            value = value[nk]
                        } else {
                            value = null
                        }
                    }
                })
                if (value || value === 0 || value === false) {
                    formData[key].value = value
                }
            }
        })
    }

    Object.keys(formData).forEach((key) => {
        if (
            (formData[key].componentName?.startsWith('Posts') && formData[key].enableNew) ||
            (formData[key].componentName?.startsWith('Posts') && formData[key].enableNewInDialog) ||
            (formData[key].schemaType === 'MongoID' && formData[key].enableNew) ||
            (formData[key].schemaType === 'MongoID' && formData[key].enableNewInDialog)
        ) {
            const refPostType = formData[key].refPostType
            formData[key].NewComponent = postTypesConfig[refPostType] && postTypesConfig[refPostType].getPages ? postTypesConfig[refPostType].getPages().new : null
        }
    })

    formData.notificationSettings = {
        isContainer: true,
        hiddenContainer: true
    }

    wapp.styles.use(style)

    return (
        <Container containerVariant={'parent'}>
            {
                <Typography
                    className={clsx(
                        style.notificationSettingsInfo,
                        TypographyProps.className
                    )}
                    variant={'h6'}
                    weight={600}
                    {...TypographyProps}
                >
                    {appContext.messages.notificationSettingsInfo}
                </Typography>
            }
            <Container container-type={'parent-side'}>
                <Form
                    className={style.notificationSettings}
                    formData={formData}
                    onSubmit={onSubmit}
                    successMessage={
                        appContext.messages.notificationSettingsSuccessMessage
                    }
                    showInitializationErrors={false}
                />
            </Container>
        </Container>
    )
}

export default withWapp(NotificationSettings)
